"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("@site/utils");
var _uxUtils = require("@site/ux-utils");
var _LeaseToOwnTermMappings = _interopRequireDefault(require("./constants/LeaseToOwnTermMappings"));
var _ToolTipWrapper = require("./ToolTipWrapper");
var _LeaseToOwnDataContextProvider = require("./LeaseToOwnDataContextProvider");
var _TermLengthSlider = _interopRequireDefault(require("./TermLengthSlider"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const LeaseToOwnServiceFees = ({
  serviceFees,
  paymentTerm
}) => {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    "data-cy": "lto-service-fees-included",
    "data-testid": "lto-service-fees-included",
    className: "ms-1 mt-3"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: 'lto.serviceFeesIncluded'
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "lto-service-fees",
    "data-testid": "lto-service-fees",
    className: "d-flex flex-column mt-1 ms-1"
  }, serviceFees.map((fee, i) => {
    return /*#__PURE__*/_react.default.createElement("span", {
      "data-cy": `lto-service-fees-${i}`,
      "data-testid": `lto-service-fees-${i}`,
      className: "mt-0",
      key: `${i}`
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "lto.serviceFees",
      values: {
        minValueRange: fee.minValueRange,
        maxValueRange: fee.maxValueRange,
        paymentTerm: _LeaseToOwnTermMappings.default[paymentTerm].term,
        percentage: fee.percentage
      }
    }));
  })));
};
LeaseToOwnServiceFees.propTypes = {
  serviceFees: _propTypes.default.array.isRequired,
  paymentTerm: _propTypes.default.string
};
const LeaseDetailsTooltip = ({
  learnMoreText,
  exactMatchDomain,
  tooltipContent,
  eidBase = ''
}) => {
  const EID = (0, _utils.getEidCodes)(eidBase);
  const message = /*#__PURE__*/_react.default.createElement("div", {
    id: "lease-details-tooltip-message",
    "data-cy": "lease-details-tooltip-message"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: tooltipContent
  })));
  const onTooltipOpenHandler = () => {
    (0, _utils.logEvent)({
      eid: `${EID.NewExactMatch}.premium_${EID.LeaseNow.LearnMore}`,
      type: 'click',
      properties: {
        domain: exactMatchDomain.Fqdn
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement(_ToolTipWrapper.TooltipWrapper, {
    tooltipContent: message,
    id: "lease-details-tooltip",
    tooltipButtonText: /*#__PURE__*/_react.default.createElement("span", {
      className: "lease-details-text text-underline"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: learnMoreText
    })),
    onOpen: onTooltipOpenHandler,
    classNames: {
      tooltipWrapper: 'mt-3'
    },
    dataCy: "lease-details-tooltip-wrapper"
  });
};
LeaseDetailsTooltip.propTypes = {
  learnMoreText: _propTypes.default.string,
  exactMatchDomain: _propTypes.default.object,
  tooltipContent: _propTypes.default.string,
  eidBase: _propTypes.default.string
};
const LeaseToOwnPicker = ({
  exactMatchDomain,
  isCardLayout,
  eidBase = '',
  leaseToOwnFeatureData
}) => {
  const {
    numPayments,
    setNumPayments,
    paymentTerm,
    minPayments,
    maxPayments,
    paymentPrice,
    setPaymentPrice,
    installmentLengthAndPrices
  } = (0, _react.useContext)(_LeaseToOwnDataContextProvider.LeaseToOwnDataContext);
  const EID = (0, _utils.getEidCodes)(eidBase);
  (0, _react.useEffect)(() => {
    setPaymentPrice(installmentLengthAndPrices[numPayments]);
  }, [installmentLengthAndPrices, numPayments]);
  const {
    learnMoreText = 'lto.leaseDetails',
    tooltipContent = 'lto.leaseDetails.toolTip',
    serviceFees = [{
      minValueRange: 1,
      maxValueRange: 12,
      percentage: 0
    }, {
      minValueRange: 13,
      maxValueRange: 24,
      percentage: 10
    }, {
      minValueRange: 25,
      maxValueRange: 36,
      percentage: 20
    }, {
      minValueRange: 37,
      maxValueRange: 60,
      percentage: 30
    }]
  } = leaseToOwnFeatureData || {};
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const {
    isMobile,
    isDesktop
  } = (0, _uxUtils.useDeviceType)();
  const ariaLabels = {
    sliderThumb: formatMessage({
      id: 'fullOwnershipMessage'
    }, {
      length: /*#__PURE__*/_react.default.createElement("b", null, numPayments),
      paymentTerm: /*#__PURE__*/_react.default.createElement("b", null, _LeaseToOwnTermMappings.default[paymentTerm].term)
    })
  };
  (0, _react.useEffect)(() => {
    document.getElementById('lto-payment-slider').addEventListener('mouseup', () => {
      (0, _utils.logEvent)({
        eid: `${EID.NewExactMatch}.premium_${EID.LeaseNow.MoveSliderPosition}`,
        type: 'click'
      });
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('lto-picker-container d-flex flex-column', {
      'ux-card border-radius-12 mb-4 justify-content-start mt-3 px-4 low-contract-bg': !isMobile && !isCardLayout,
      'w-ch-40': isDesktop && !isCardLayout,
      'w-ch-60': isDesktop && isCardLayout
    }),
    "data-cy": "lto-picker-container",
    "data-testid": "lto-picker-container"
  }, !isCardLayout && /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-between",
    "data-cy": "lto-label-with-price",
    "data-testid": "lto-label-with-price"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "font-weight-bold align-items-start ms2"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "lto.leaseToOwn"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex flex-column lto-pick-payment-slider",
    "data-cy": "lto-pick-payment-slider",
    "data-testid": "lto-pick-payment-slider"
  }, !isCardLayout && /*#__PURE__*/_react.default.createElement("span", {
    className: "ms-1 mt-3",
    "data-cy": "lto-pick-price"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "lto.pickPriceMessage"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "lto-installment-payment ux-card d-flex my-3 bg-white bd-black justify-content-center",
    "data-cy": "lto-installment-payment",
    "data-testid": "lto-installment-payment"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "d-flex flex-column font-weight-bold bd-r-1 my-2 px-2 text-uppercase bd-black w-100"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "ms-2",
    "data-cy": "lto-payment-term",
    "data-testid": "lto-payment-term"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: _LeaseToOwnTermMappings.default[paymentTerm].perTermString
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex ms0",
    "data-cy": "lto-payment-price",
    "data-testid": "lto-payment-price"
  }, paymentPrice)), /*#__PURE__*/_react.default.createElement("span", {
    className: "d-flex flex-column font-weight-bold my-2 px-2 text-uppercase w-100"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "ms-2",
    "data-cy": "lto-months",
    "data-testid": "lto-months"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: _LeaseToOwnTermMappings.default[`${paymentTerm}`].termString
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ms0",
    "data-cy": "lto-installments",
    "data-testid": "lto-installments"
  }, numPayments))), /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "lto-payment-slider",
    "data-testid": "lto-payment-slider"
  }, /*#__PURE__*/_react.default.createElement(_TermLengthSlider.default, {
    id: "lto-payment-slider",
    additionalClassNames: "lto-payment-slider",
    minTerm: minPayments,
    maxTerm: maxPayments,
    selectedTerm: numPayments,
    setSelectedTerm: setNumPayments,
    ariaLabels: ariaLabels
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-1 ms-1",
    "data-cy": "lto-fullOwnershipMessage",
    "data-testid": "lto-fullOwnershipMessage"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: 'lto.fullOwnershipMessageTerm.2',
    values: {
      length: /*#__PURE__*/_react.default.createElement("b", null, numPayments),
      paymentTerm: /*#__PURE__*/_react.default.createElement("b", null, _LeaseToOwnTermMappings.default[paymentTerm].term)
    }
  })), !isCardLayout && /*#__PURE__*/_react.default.createElement(LeaseToOwnServiceFees, {
    serviceFees: serviceFees,
    paymentTerm: paymentTerm
  }), /*#__PURE__*/_react.default.createElement(LeaseDetailsTooltip, {
    learnMoreText: learnMoreText,
    exactMatchDomain: exactMatchDomain,
    tooltipContent: tooltipContent,
    eidBase: eidBase
  })));
};
LeaseToOwnPicker.propTypes = {
  exactMatchDomain: _propTypes.default.object,
  isCardLayout: _propTypes.default.bool,
  eidBase: _propTypes.default.string,
  leaseToOwnFeatureData: _propTypes.default.shape({
    learnMoreText: _propTypes.default.string,
    tooltipContent: _propTypes.default.string,
    serviceFees: _propTypes.default.arrayOf(_propTypes.default.shape({
      minValueRange: _propTypes.default.number,
      maxValueRange: _propTypes.default.number,
      percentage: _propTypes.default.number
    })),
    defaultTermLengthOverride: _propTypes.default.number
  })
};
var _default = exports.default = LeaseToOwnPicker;